import { styled } from "@mui/material/styles";
import {
  MenuItem as MuiMenuItem,
  FormControl as MuiFormControl,
} from "@mui/material";

export const StyledFormControl = styled(MuiFormControl)({
  margin: "8px 0",
  "& .MuiInputLabel-root": {
    backgroundColor: "white",
    padding: "0 4px",
  },
});

export const StyledMenuItem = styled(MuiMenuItem)({
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
});
